export interface IProject {
  CategoryId: number;
  DivisionId: number;
  EntryTypeId: number;
  category: string; // "Energy and Transportation"
  categoryAwards: number[];
  files: any[]; // null
  images: any[]; // []
  myTags: number[]; // [1]
  owners: any[]; // [{…}]
  projectAbstract: string; // null
  projectDescription: string; // ""
  projectId: string; // "ET-002"
  projectPlan: string; // null
  publicId: string; // "afde3c76-53e0-43d2-824d-ff48d7bcc238"
  searchString: string;
  specialAwards: number[];
  title: string; // "Testing"
  shortTitle?: string;
  videoUrl: string; //
  videoUrl2: string; //
  EntryFile: boolean;
  EntryUrl: number; //55688187.NHDWebCentral.org/
  WrittenMatterials: boolean;
  projectIntId: number;
  projectQuestionsResponses: ICustomQuestionResponse[];
  formResponses?: IFormResponseRecord[];
}

export interface IFormResponseRecord {
  ResponseId: number;
  ResponsePublicId: string;
  FormId: number;
  FormPublicId: string;
  ProjectId: number;
  ProjectPublicId: string;
  FormName: string;
}

export interface ICustomQuestionResponse {
  LinkedId: number;
  QuestionId: number;
  ResponseId: number;
  Value: string;
}

export interface IShowcaseSettings {
  canLike: boolean;
  entrySlidesUpload: boolean;
  entryVideoUpload: boolean;
  entrylogbookUpload: boolean;
  hideShowcaseStudentName: boolean;
  hideShowcaseStudentProfileImages: boolean;
  profileImagesInTiles: boolean;
  recordLikes: boolean;
  recordTopEntries?: boolean;
  canSelectTopEntries?: boolean;
  topEntriesMax?: number;
  showTopEntryCounts?: boolean;
  showAwards: boolean;
  showPitchVideo: boolean;
  showVideo: boolean;
  showSlides: boolean;
  showLogbook: boolean;
  slidesAsTileImage: boolean;
  showShortTitle?: boolean;
  text: IShowcaseText;
}

export interface ITopEntryPick {
  ProjectId: number;
  Rank: number;
  Title: string;
  ProjectCode: string;
}

export interface ISetTopEntryResult {
  projectId: number;
  rank: number;
  selected: boolean;
  myTopEntries: ITopEntryPick[];
  topEntryCounts: { [projectId: string]: number } | null;
}

export function nextOpenTopRank(picks: ITopEntryPick[], max: number): number | null {
  const used = new Set(picks.map((p) => p.Rank));
  for (let i = 1; i <= max; i++) {
    if (!used.has(i)) return i;
  }
  return null;
}

export function topRankByProjectId(picks: ITopEntryPick[]): { [projectId: number]: number } {
  const dic: { [projectId: number]: number } = {};
  picks.forEach((p) => {
    dic[p.ProjectId] = p.Rank;
  });
  return dic;
}

export interface IShowcaseText {
  abstractLabel: string;
  descriptionLabel: string;
  shortTitleLabel?: string;
}

export interface ICustomQuestions {
  ColumnName: string;
  FieldType: number;
  Ignore: boolean;
  IsSlave?: boolean;
  MasterId?: number;
  Required: boolean;
  Sort: number;
  defaultValue: string;
  fairId: number;
  for: number;
  id: number;
  possibleValuesCsv: string;
  question: string;
  rubricId: string;
  type: string;
}

export interface IAward {
  Id: number;
  Name: string;
}

export interface ITag {
  FairId: number; //1
  Id: number; //1
  Type: string; //"project"
  Value: string; //
}
